var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMpaaa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 57,
    viewBox: "0 0 159 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1738_26494",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 33,
    width: 21,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 33.0277H20.0801V56.9822H0V33.0277Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1738_26494)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75897 45.7296C11.9365 45.7296 12.7001 44.3574 12.7001 41.4958C12.7001 38.7913 11.8945 37.5759 9.75897 37.5759H7.09636V45.7296H9.75897ZM7.09627 56.9822H0V33.0277H11.5312C16.976 33.0277 20.0802 35.9288 20.0802 41.4547C20.0802 46.9853 16.613 50.0438 11.2096 50.0438H7.09627V56.9822Z",
    fill: "#0F133F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1074 50.1818H29.193V25.3636H22.1074V50.1818Z",
    fill: "#0F133F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0273 42.395V33H39.1238V41.8839C39.1238 44.4405 39.5681 45.4218 41.7856 45.4218C44.0039 45.4218 44.4886 44.4405 44.4886 41.8839V33H51.5835V42.395C51.5835 48.3703 48.4785 50.4545 41.7856 50.4545C35.0932 50.4545 32.0273 48.3703 32.0273 42.395",
    fill: "#0F133F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5664 41.1419C53.5664 35.8434 56.0867 33.2322 61.6463 33.2732H74.7197C80.2417 33.2732 82.7589 35.8434 82.7589 41.1419V50.1818H75.6136V41.6097C75.6136 39.0006 75.127 38.0237 73.0542 38.0237H71.2699V50.1818H65.0983V38.0237H63.3112C61.2015 38.0237 60.7123 39.0006 60.7123 41.6097V50.1818H53.5664V41.1419Z",
    fill: "#0F133F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.8045 45.8675C96.9862 45.8675 97.7537 44.4952 97.7537 41.6336C97.7537 38.929 96.9473 37.7135 94.8045 37.7135H92.1378V45.8675H94.8045ZM85.0273 25.3636H92.1379V33.1653H96.5827C102.038 33.1653 105.15 36.0665 105.15 41.5925C105.15 47.1232 101.672 50.1818 96.2603 50.1818H85.0273V25.3636Z",
    fill: "#0F133F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.769 36.6193C114.946 36.6193 113.893 37.2885 113.61 39.9995H119.762C119.604 37.4459 118.754 36.6193 116.769 36.6193M117.173 45.8574H124.988V50.1818H115.839C110.211 50.1818 106.283 47.7846 106.283 41.571C106.283 35.3615 110.168 32.7273 116.607 32.7273C123.37 32.7273 126.406 35.6758 126.406 41.1397V43.0668H113.691C114.015 45.3456 115.15 45.8574 117.173 45.8574",
    fill: "#0F133F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.107 41.0255C128.107 35.9991 130.676 33.2727 136.138 33.2727H140.578V38.2584H137.765C135.85 38.2584 135.279 39.1952 135.279 41.6889V50.1818H128.107V41.0255Z",
    fill: "#0F133F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.792 46.1686H150.011C151.059 46.1686 152.026 45.9336 152.026 44.8424C152.026 43.7134 151.26 43.5188 150.092 43.5188H147.23C144.128 43.5188 141.428 42.1555 141.428 38.4544C141.428 34.5563 144.57 33.2727 147.674 33.2727H157.952V37.2835H150.336C149.084 37.2835 148.359 37.5954 148.359 38.5695C148.359 39.4664 149.045 39.8167 150.214 39.8167H152.954C156.26 39.8167 159 41.1417 159 44.9217C159 48.9734 156.177 50.1818 153.034 50.1818H141.792V46.1686Z",
    fill: "#0F133F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6015 15.1934C38.4327 15.1934 37.8279 15.5828 37.8279 16.6743C37.8279 17.7654 38.4716 18.1154 39.6015 18.1154H43.5943V15.1934H39.6015ZM41.2954 9.4658H32.7084V5.18176H43.4338C48.1489 5.18176 50.4487 7.82894 50.4487 12.8163V22.0909H36.8591C33.2735 22.0909 30.8926 20.7256 30.8926 17.0236C30.8926 13.2446 33.3518 11.9219 36.8591 11.9219H43.5942C43.5115 10.2841 42.9507 9.4658 41.2954 9.4658V9.4658Z",
    fill: "#00AAE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2293 18.077H60.4516C61.4983 18.077 62.4664 17.842 62.4664 16.7517C62.4664 15.6218 61.7007 15.4293 60.5325 15.4293H57.6705C54.5657 15.4293 51.8672 14.064 51.8672 10.3641C51.8672 6.46622 55.0115 5.18176 58.1128 5.18176H68.3902V9.19321H60.773C59.5246 9.19321 58.7986 9.50483 58.7986 10.4786C58.7986 11.376 59.4826 11.7264 60.6508 11.7264H63.3932C66.6972 11.7264 69.4394 13.0512 69.4394 16.8301C69.4394 20.8815 66.617 22.0909 63.4733 22.0909H52.2293V18.077Z",
    fill: "#00AAE4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7227 9.45054V5.21219H72.5009V0H79.5893V5.21219H84.4606V9.45054H79.5893V14.623C79.5893 16.9159 80.1937 17.5401 82.0038 17.5401H84.0169V22.0909H79.5082C74.7955 22.0909 72.5009 20.3396 72.5009 14.9326V9.45054H69.7227Z",
    fill: "#00AAE4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7986 8.52858C93.9756 8.52858 92.9241 9.19719 92.6411 11.9088H98.793C98.6301 9.35428 97.783 8.52858 95.7986 8.52858M96.2017 17.767H104.016V22.0909H94.8668C89.2406 22.0909 85.3105 19.6934 85.3105 13.4813C85.3105 7.27144 89.1974 4.63635 95.6368 4.63635C102.397 4.63635 105.434 7.58493 105.434 13.0491V14.9748H92.7217C93.0447 17.2551 94.1777 17.767 96.2017 17.767",
    fill: "#00AAE4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.133 12.9339C107.133 7.90831 109.7 5.18176 115.162 5.18176H119.603V10.1675H116.792C114.877 10.1675 114.307 11.1036 114.307 13.5972V22.0909H107.133V12.9339Z",
    fill: "#00AAE4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3305 13.5181V22.0909H29.4757V13.0512C29.4757 7.75258 26.9588 5.18221 21.4376 5.18221H8.36427C2.8011 5.14224 0.283203 7.75258 0.283203 13.0512V22.0909H7.42878V13.5181C7.42878 10.9096 7.91796 9.93275 10.0284 9.93275H11.8158V22.0909H17.9868V9.93275H19.7726C21.8439 9.93275 22.3305 10.9096 22.3305 13.5181",
    fill: "#00AAE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpaaa);
export default __webpack_public_path__ + "static/media/MPAAA.4019232f0343d8d8c11d74876fe5c235.svg";
export { ForwardRef as ReactComponent };